module.exports = __webpack_public_path__ + "img/img2.b1a868c7.png";